import { ClientNamePOS, ClientNamePOSData } from "@/domain/entities/Partner";
import { DetailClientManagement } from "@/domain/entities/ClientManagement";

export interface PickupSelectedClient {
  clientId: string;
  clientParentId: string;
  clientRef: string;
}

export function mapClientDetailToPickupClient(
  detail: DetailClientManagement
): PickupSelectedClient {
  return {
    clientId: detail.clientCode,
    clientParentId: detail.clientParentCode,
    clientRef: detail.clientName
  };
}

export function dedupeClientOptions(
  options: ClientNamePOSData[]
): ClientNamePOSData[] {
  return options.filter(
    (option, index, items) =>
      items.findIndex((item) => item.clientId === option.clientId) === index
  );
}

export function hasNextClientDirectoryPage(
  response: ClientNamePOS,
  loadedCount: number
): boolean {
  const totalData = response.pagination.totalData;
  if (typeof totalData === "number") return loadedCount < totalData;
  return response.data.length === response.pagination.limit;
}
